// Collapsible group with a dark icon badge, used across the details panel.

import { useState } from 'react';
import { CollapseBody, CollapseHeader } from './collapse-toggle';

export function SectionCard({
  icon,
  title,
  action,
  defaultOpen = true,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  action?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="flex w-full flex-col px-1">
      <div className="flex w-full items-center gap-1">
        <CollapseHeader open={open} label={title} variant="chevron" onToggle={() => setOpen((prev) => !prev)}>
          <span className="flex items-center gap-1.5">
            <span className="flex size-5 shrink-0 items-center justify-center rounded bg-text-prose text-white">
              {icon}
            </span>
            <span className="text-[12px] font-medium leading-[1.1] text-text-body">{title}</span>
          </span>
        </CollapseHeader>
        {/* Outside the header: a control cannot sit inside the button that toggles. */}
        {action}
      </div>
      <CollapseBody open={open} className="px-1">
        <div className="pt-3.5">{children}</div>
      </CollapseBody>
    </div>
  );
}
